export default class LZStringMod {
  /**
   * 旧シミュレータセーブデータ復元用
   * まさに負の遺産 ばかたれ
   * @static
   * @param {string} input
   * @return {*}  {string}
   * @memberof LZStringMod
   */
  public static decompressFromEncodedURIComponent(input: string): string {
    if (input === null) return '';
    if (input === '') return '';

    const baseReverseDic: { [key: string]: number } = {};
    const keyStrUriSafe = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_$';
    for (let i = 0; i < keyStrUriSafe.length; i += 1) {
      baseReverseDic[keyStrUriSafe.charAt(i)] = i;
    }
    input = input.replace(/ /g, '+');
    return LZStringMod.decompress(input.length, 32, (index) => baseReverseDic[input.charAt(index)]);
  }

  /* eslint-disable */
  private static decompress(length: number, resetValue: number, getNextValue: (i: number) => number): string {
    const f = String.fromCharCode;
    const dictionary = [];
    let enlargeIn = 4;
    let dictSize = 4;
    let numBits = 3;
    let entry: any = '';
    const result = [];
    let next; let i; let w; let bits; let resb; let maxPower; let power; let c;
    const data = { val: getNextValue(0), position: resetValue, index: 1 };

    for (i = 0; i < 3; i += 1) {
      dictionary[i] = i;
    }

    bits = 0;
    maxPower = Math.pow(2, 2);
    power = 1;
    while (power != maxPower) {
      resb = data.val & data.position;
      data.position >>= 1;
      if (data.position == 0) {
        data.position = resetValue;
        data.val = getNextValue(data.index++);
      }
      bits |= (resb > 0 ? 1 : 0) * power;
      power <<= 1;
    }

    switch (next = bits) {
      case 0:
        bits = 0;
        maxPower = Math.pow(2, 8);
        power = 1;
        while (power != maxPower) {
          resb = data.val & data.position;
          data.position >>= 1;
          if (data.position == 0) {
            data.position = resetValue;
            data.val = getNextValue(data.index++);
          }
          bits |= (resb > 0 ? 1 : 0) * power;
          power <<= 1;
        }
        c = f(bits);
        break;
      case 1:
        bits = 0;
        maxPower = Math.pow(2, 16);
        power = 1;
        while (power != maxPower) {
          resb = data.val & data.position;
          data.position >>= 1;
          if (data.position == 0) {
            data.position = resetValue;
            data.val = getNextValue(data.index++);
          }
          bits |= (resb > 0 ? 1 : 0) * power;
          power <<= 1;
        }
        c = f(bits);
        break;
      case 2:
        return '';
      default:
      // no;
    }
    dictionary[3] = c;
    w = c;
    result.push(c);
    while (true) {
      if (data.index > length) {
        return '';
      }

      bits = 0;
      maxPower = Math.pow(2, numBits);
      power = 1;
      while (power != maxPower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position == 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index++);
        }
        bits |= (resb > 0 ? 1 : 0) * power;
        power <<= 1;
      }

      switch (c = bits) {
        case 0:
          bits = 0;
          maxPower = Math.pow(2, 8);
          power = 1;
          while (power != maxPower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb > 0 ? 1 : 0) * power;
            power <<= 1;
          }

          dictionary[dictSize++] = f(bits);
          c = dictSize - 1;
          enlargeIn--;
          break;
        case 1:
          bits = 0;
          maxPower = Math.pow(2, 16);
          power = 1;
          while (power != maxPower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb > 0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize++] = f(bits);
          c = dictSize - 1;
          enlargeIn--;
          break;
        case 2:
          return result.join('');
        default:
        // no;
      }

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

      if (dictionary[c]) {
        entry = dictionary[c];
      } else if (c === dictSize) {
        entry = w + w.charAt(0);
      } else {
        return '';
      }
      result.push(entry);

      // Add w+entry[0] to the dictionary.
      dictionary[dictSize++] = w + entry.charAt(0);
      enlargeIn--;

      w = entry;

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }
    }
  }
}
